export default [
  {
    path: "/product/list",
    name: "product-list",
    component: () => import("@/views/pages/product/product-list/ProductList.vue"),
    meta: {

    },
  },
];
